module.exports = __webpack_public_path__ + "img/1.ec35bea3.jpg";